module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [(_vm.list.length > 0) ? _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.dakejian.img2025331
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "savebtn",
    staticStyle: {
      "text-align": "center",
      "position": "absolute",
      "bottom": "50px",
      "left": "0",
      "right": "0"
    }
  }, [_c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'HuiyiApplyFormStep1',
        query: {
          saiqu_id: 692
        }
      }),
      expression: "{name:'HuiyiApplyFormStep1',query:{saiqu_id:692}}"
    }],
    staticStyle: {
      "width": "2.7rem",
      "margin": "0 auto",
      "font-size": "12px"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("报名入口\n              ")])], 1)]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.list[0].pic_url
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "savebtn",
    staticStyle: {
      "text-align": "center",
      "position": "absolute",
      "bottom": "40px",
      "left": "0",
      "right": "0"
    }
  }, [_c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'HuiyiApplyFormStep1',
        query: {
          saiqu_id: 446
        }
      }),
      expression: "{name:'HuiyiApplyFormStep1',query:{saiqu_id:446}}"
    }],
    staticStyle: {
      "width": "2.7rem",
      "margin": "0 auto",
      "font-size": "12px"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("七彩星级培训班\n                      ")]), _vm._v(" "), _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'HuiyiApplyFormStep1',
        query: {
          saiqu_id: 444
        }
      }),
      expression: "{name:'HuiyiApplyFormStep1',query:{saiqu_id:444}}"
    }],
    staticStyle: {
      "width": "1.5rem"
    },
    attrs: {
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("导师团\n                      ")]), _vm._v(" "), _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'HuiyiApplyFormStep1',
        query: {
          saiqu_id: 443
        }
      }),
      expression: "{name:'HuiyiApplyFormStep1',query:{saiqu_id:443}}"
    }],
    staticStyle: {
      "width": "2rem"
    },
    attrs: {
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("331文化纪\n                      ")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_vm._l((_vm.list), function(item, index) {
    return _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'Page331',
          query: {
            id: item.id
          }
        }),
        expression: "{name:'Page331',query:{id:item.id}}"
      }],
      key: index,
      staticStyle: {
        "position": "relative"
      }
    }, [_c('div', {
      staticStyle: {
        "padding": "10px"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": item.pic_url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "savebtn",
      staticStyle: {
        "text-align": "center",
        "position": "absolute",
        "bottom": "30px",
        "left": "30px"
      }
    }, [_c('van-button', {
      staticStyle: {
        "width": "3rem",
        "margin": "0 auto"
      },
      attrs: {
        "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
        "size": "normal",
        "round": ""
      }
    }, [_vm._v("进入专题\n            ")])], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "news-title "
  }, [_vm._v(_vm._s(_vm.row.title))]), _vm._v(" "), _c('div', {
    staticClass: "news-read-time"
  }), _vm._v(" "), _c('div', {
    staticClass: "news-content",
    staticStyle: {
      "padding": "0 10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.row.content)
    }
  })], 2)]), _vm._v(" "), _c('TabBar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isApp),
      expression: "!isApp"
    }],
    attrs: {
      "show-tab-bar": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e74904fa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/page/Wenhuaji.vue
// module id = 2603
// module chunks = 0